<app-header></app-header>
<section class="container clearfix pt-5 pb-5">
  <div class="row">
    <div class="col-12 col-md-12 col-lg-12 col-xl-12 offset-0 offset-md-0 offset-lg-0 offset-xl-0 mt-4 pb-3 text-md-left">
			<h1 data-animate-effect="fadeIn">Programa de Apertura</h1>
      <p class="mt-3">El objetivo del Plan de Apertura 2020 consiste en comunicar y brindar una herramienta par dar seguimiento a aquellos conjuntos de datos que estarán en formato de datos abiertos en el Portal de Datos Abiertos a lo largo de este año como parte del trabajo de la Agencia Digital de Innovación Pública (ADIP).</p>
      <img src="assets/images/paginas-datos01.png" width="100%" alt="" class="rounded-corners mt-4">
    </div>
    <div class="col-12 mt-4 mb-5 text-center">
      <h2>Conjuntos de datos destacados</h2>
      <p>A continuación se enlistan bases de datos que, por su relevancia pública, generan un impacto mayor.</p>
    </div>
    <div class="col-12 col-sm-12 col-md-6 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-info text-light">
          <h4 class="ml-3 mt-3"><fa-icon [icon]="faInfoCircle"></fa-icon> Contratos de adquisiciones de la Ciudad de México</h4>
        </div>
        <div class="card-body p-4 p-md-5">
          <p><b>¿Qué es?</b> Este conjunto de datos brinda información de contratos adjudicados de los procedimientos de compras públicas registrados en Tianguis Digital por las unidades administrativa de la Administración Pública de la Ciudad de México.</p>
          <p><b>¿Por qué es importante?</b> La relevancia de este conjunto de datos radica en tener registro de los contratos que ha adjudicado la Administración Pública de la Ciudad de México, que abarca desde a quién, qué y cómo se adquirieron los bienes y servicios comprados.</p>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-6 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-info text-light">
          <h4 class="ml-3 mt-3"><fa-icon [icon]="faInfoCircle"></fa-icon> Remuneraciones al personal</h4>
        </div>
        <div class="card-body p-4 p-md-5">
          <p><b>¿Qué es?</b> La base de datos cuenta con información de las remuneraciones del personal operativo, estructura, provisional y honorarios de 49 dependencias del Gobierno de la Ciudad de México y las 16 Alcaldías.</p>
          <p><b>¿Por qué es importante?</b> La Ciudad de México tiene el compromiso de transparentar sus finanzas, entre ellas las remuneraciones de su personal. Esta base muestra los sueldos brutos y netos de las personas servidoras públicas del Gobierno de la Ciudad de México, lo cual representa más de una tercera parte del total del Presupuesto de Egresos de la Ciudad.</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-6 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-info text-light">
          <h4 class="ml-3 mt-3"><fa-icon [icon]="faInfoCircle"></fa-icon> Padrón homologado de beneficiarios de programas sociales</h4>
        </div>
        <div class="card-body p-4 p-md-5">
          <p><b>¿Qué es?</b> La base de datos cuenta con los nombres de todas las personas derechohabientes de los programas sociales del Gobierno de la Ciudad de México y de las Alcaldías aprobados por el Comité de Planeación del Desarrollo (COPLADE).</p>
          <p><b>¿Por qué es importante?</b> La información del padrón homologado de derechohabientes permite contabilizar los montos otorgados por cada Programa Social y a cada uno de los beneficiarios. Esta información permite tener un conocimiento más completo de la política social de la Ciudad.</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-6 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-info text-light">
          <h4 class="ml-3 mt-3"><fa-icon [icon]="faInfoCircle"></fa-icon> Ubicación de unidades de transporte público (RTP, ORT)</h4>
        </div>
        <div class="card-body p-4 p-md-5">
          <p><b>¿Qué es?</b> Unificación y centralización de los conjuntos que proporcionan información en tiempo real de las unidades del transporte público en la Ciudad de México.</p>
          <p><b>¿Por qué es importante?</b> En el Portal de Datos existe información sobre concesiones público-privadas como metro, metrobús, RTP, y otros del sistema de movilidad integrada. También existe una primera iteración de la base de transporte público concesionado.</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-6 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-info text-light">
          <h4 class="ml-3 mt-3"><fa-icon [icon]="faInfoCircle"></fa-icon> Declaraciones patrimonial y de intereses</h4>
        </div>
        <div class="card-body p-4 p-md-5">
          <p><b>¿Qué es?</b> Esta base contiene la versión pública de la declaración patrimonial y de intereses de todas y todos los funcionarios públicos de la Administración Pública de la Ciudad de México resultado formato aprobado por el Comité Coordinador del Sistema Nacional Anticorrupción.</p>
          <p><b>¿Por qué es importante?</b> Este conjunto de datos se pone a disposición de la población con el objetivo de promover la colaboración en la detección e investigación de de probables casos de corrupción, enriquecimiento ilícito, colusión, conflicto de intereses, y así combatir la corrupción y la impunidad.</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-6 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-info text-light">
          <h4 class="ml-3 mt-3"><fa-icon [icon]="faInfoCircle"></fa-icon>  Servidores públicos en procesos de contratación pública</h4>
        </div>
        <div class="card-body p-4 p-md-5">
          <p><b>¿Qué es?</b> Esta base presenta información de los servidores públicos de la Ciudad de México que intervienen en los procedimientos de adquisiciones, arrendamientos, servicios y obras públicas respetando la normatividad vigente.</p>
          <p><b>¿Por qué es importante?</b> Este conjunto transparenta la información sobre las servidoras públicas involucradas en procesos de compra de la Ciudad de México, así como los datos de la dependencia para la que trabajan y su cargo actual.</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-6 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-info text-light">
          <h4 class="ml-3 mt-3"><fa-icon [icon]="faInfoCircle"></fa-icon> Servidores públicos sancionados</h4>
        </div>
        <div class="card-body p-4 p-md-5">
          <p><b>¿Qué es?</b> Información sobre los servidores públicos sancionados o inhabilitados derivado de un proceso administrativo ya sea a nivel local o federal.</p>
          <p><b>¿Por qué es importante?</b> Este conjunto transparenta la información sobre las personas servidoras públicos sancionados o inhabilitados, así como la dependencia y el cargo que desempeñaban cuando fueron sancionados.</p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-6 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-info text-light">
          <h4 class="ml-3 mt-3"><fa-icon [icon]="faInfoCircle"></fa-icon> Egresos Hospitalarios</h4>
        </div>
        <div class="card-body p-4 p-md-5">
          <p><b>¿Qué es?</b> La información de egresos hospitalarios en la Ciudad de México, permite conocer la demanda de atención de los servicios de hospitalización. Proporciona información sobre morbilidad (que comprende todos los casos atendidos en los hospitales) y mortalidad (aquellos casos en los que el motivo del egreso fue la defunción).</p>
          <p><b>¿Por qué es importante?</b> La información sobre egresos hospitalarios brinda apoyo para la planeación y toma de decisiones en el ámbito de la salud. Cuenta con datos sobre la afección principal de los pacientes y causa de muerte. Esta información ampliará sustancialmente la información sobre salud en el Portal de Datos Abiertos.</p>
        </div>
      </div>
    </div>

    <!-- div
      class="col-12 col-md-12 col-lg-12 col-xl-12 offset-0 offset-md-0 offset-lg-0 offset-xl-0 mt-4 pb-3 text-md-left">
      <div class="alert alert-success p-4">
        <div class="row">
          <div class="col-12">
            <h1>¡Atención!</h1>
            <h4 class="mt-4">La información de este sitio está siendo actualizada, muy pronto estará disponible nuevamente!</h4>
            <hr>
            <p class="mt-5">El Portal de Datos Abiertos está cambiando. En la ADIP estamos trabajando para ofrecerle a la Ciudad de México un portal que ayude a transitar a cualquier persona de dudas sobre la CDMX a respuestas basadas en datos. </p>
            <a href="https://paginas.datos.cdmx.gob.mx/plan-accion">Leer más</a>
          </div>
        </div>
      </div>
    </div -->

    <div class="col-12 text-center mt-4">
      <h2 class="mb-4">Todas las bases</h2>
      <iframe width="100%" height="680" src="https://datos.cdmx.gob.mx/dataset/plan-de-apertura-2020/resource/69c5f391-6b85-4e47-aa73-cba0a4708f36/view/3b3f04f5-b5d9-4a2f-9674-a3fda4fad688" frameBorder="0"></iframe>
    </div>
    <!-- div class="col-12 col-md-6 mt-4 mt-md-0 text-center">
      <button type="button" name="button" class="btn btn-lg btn-success">Mira el plan completo</button>
    </div>
    <div class="col-12 col-md-6 mt-3 mt-md-0 text-center">
      <button type="button" name="button" class="btn btn-lg btn-success">Centro de apertura</button>
    </div -->

    <div class="col-12 text-center mt-5">
      <h2>Avance</h2>

      <p class="mt-3">A continuación se muestra una gráfica que señala el avance en el Plan de Apertura.</p>
      <p *ngIf="resultados">Registros totales: {{resultados.total}}</p>
    </div>
    <div class="col-12 col-md-8 offset-0 offset-md-2 mb-5" *ngIf="resultados">
      <app-pie-chart [data]="resultados"></app-pie-chart>
    </div>

  </div>
</section>

<app-footer></app-footer>
